import { Chip as MuiChip } from '@mui/material'
import { styled } from '@mui/material/styles'
import { XCircle } from '@phosphor-icons/react'
import { tokens } from 'ComponentLibrary'
import { ReactElement } from 'react'

export type InputChipProps = {
    label: string
    disabled?: boolean
    icon?: ReactElement
    deleteChip?: () => void
}

export function InputChip({ label, deleteChip, disabled = false, icon }: InputChipProps) {
    return (
        <StyledChip
            aria-label={label}
            label={label}
            variant="outlined"
            clickable={false}
            onDelete={deleteChip}
            deleteIcon={deleteChip && <StyledDeleteIcon weight="fill" />}
            disabled={disabled}
            icon={icon}
        />
    )
}

const StyledDeleteIcon = styled(XCircle)(() => ({
    fill: tokens.ColorIconLinkDefault,
    '&:hover': {
        fill: tokens.ColorIconLinkHover,
    },
    '&:active': {
        fill: tokens.ColorIconLinkHover,
    },
}))

const StyledChip = styled(MuiChip)(() => ({
    height: '32px',
    ...tokens.Link,
    width: 'fit-content',
    borderRadius: tokens.SizingCornerRound,
    gap: tokens.SizingSpacing075,
    padding: `0 ${tokens.SizingSpacing150}`,
    border: `${tokens.SizingBorderS} solid`,
    borderColor: tokens.ColorBorderDefault,
    backgroundColor: tokens.ColorSurfaceDefault,
    '& .MuiChip-label': {
        padding: 0,
        color: tokens.ColorTextDefault,
    },
    '& *:not(.MuiChip-label)': {
        margin: 0,
        width: tokens.SizingIconS,
        height: tokens.SizingIconS,
        color: tokens.ColorTextDefault,
    },
    '&.Mui-disabled': {
        borderColor: tokens.ColorSurfaceDisabled,
        backgroundColor: tokens.ColorSurfaceDisabled,
        opacity: 1,
        '& .MuiChip-label': {
            color: tokens.ColorTextDisabled,
        },
        '& *:not(.MuiChip-label)': {
            color: tokens.ColorIconDisabled,
        },
    },
}))
